const BrandMap = new Map();

BrandMap.set("tucci", "Tucci");
BrandMap.set("treasure_garden", "Treasure Garden");
BrandMap.set("poggesi", "Poggesi");
BrandMap.set("fiberbuilt", "Fiberbuilt");
BrandMap.set("fiberlite", "Fiberlite");
BrandMap.set("bambrella", "Bambrella");
BrandMap.set("california_umbrellas", "California Umbrellas");
BrandMap.set("galtech", "Galtech");
BrandMap.set("shademaker", "Shademaker",);
BrandMap.set("jardinico", "Jardinico",);
BrandMap.set("caravita", "Caravita");
BrandMap.set("kettal", "Kettal");
BrandMap.set("woodline", "Woodline");
BrandMap.set("royal_botania", "Royal Botania");
BrandMap.set("midtown", "Midtown");
BrandMap.set("lloyd_flanders", "Lloyd Flanders");
BrandMap.set("castelle", "Castelle",);
BrandMap.set("meadowcraft", "Meadowcraft");
BrandMap.set("cabana_coast", "Cabana Coast");
BrandMap.set("ledge_lounger", "Ledge Lounger");
BrandMap.set("brown_jordan", "Brown Jordan");
BrandMap.set("gloster", "Gloster");
BrandMap.set("tropitone", "Tropitone");

export default BrandMap;
